// extracted by mini-css-extract-plugin
export var addToCartButton = "_nu-b";
export var arrowButtonContainer = "_nu-9";
export var arrowButtonIcon = "_nu-a";
export var carouselArrowButton = "_nu-6";
export var carouselElementContainer = "_nu-1";
export var galleryThumbnail = "_nu-d";
export var galleryThumbnailImage = "_nu-e";
export var left = "_nu-7";
export var productDisplayCarouselContainer = "_nu-0";
export var productTileContainer = "_nu-2";
export var productTileImage = "_nu-4";
export var productTileImageContainer = "_nu-3";
export var productTileTitle = "_nu-5";
export var right = "_nu-8";
export var sliderOverflow = "_nu-c";